
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisProposal as ObiAisProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-proposal.js';
 
 
 

 
 export const ObiAisProposal = createComponent({
   react: React,
   tagName: 'obi-ais-proposal',
   elementClass: ObiAisProposalElement,
   events: {
     
   }
  });
 
 